import { EDITOR_TYPES, isDimensionReportEditorSchema } from 'reporting-data/tsTypes/editorTypes';
import { BaseDimensionEditor } from './BaseDimensionEditor';
import { DATA_WELL } from 'reporting-data/constants/chartTypes';
import { AGGREGATION, TIME_SERIES } from 'reporting-data/constants/configTypes';
import { DATE, DATE_TIME } from 'reporting-data/constants/property-types';
import { getConfigType, getDimensions } from 'reporting-data/report/configReportGetters';
import { getCustomWidgetType, getReportChartType } from 'reporting-data/report/reportGetters';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
//@ts-expect-error Untyped import
import Widgets from 'reporting-ui-components/components/customWidgets/constants/widgets';
import { ReportOptionsCategories } from '../../singleReportViewer/fullPage/sidebar/categorized/ReportOptionCategory';
import getConfigDataType from '../common/getConfigDataType';
import { updateDimensions } from '../common/configReportHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
export const strategy = {
  isSupportedForReport: report => {
    return isConfigReport(report) && [AGGREGATION, TIME_SERIES].includes(getConfigType(report));
  },
  updateReport: (report, dimensionProperties) => {
    const isTimeSeries = dimensionProperties.length > 0 && [DATE, DATE_TIME].includes(dimensionProperties[0].type);
    const dimensionNames = dimensionProperties.map(property => property.name);
    return updateDimensions(report, dimensionNames, isTimeSeries);
  },
  getDataType: getConfigDataType,
  getCurrentValue: report => getDimensions(report).toJS(),
  isClearable: (editorType, report) => editorType === EDITOR_TYPES.BREAKDOWN && getCustomWidgetType(report) !== Widgets.PIPELINE_SNAPSHOTS || getReportChartType(report) === DATA_WELL
};
const SingleObjectDimensionEditorComponent = props => {
  return /*#__PURE__*/_jsx(BaseDimensionEditor, Object.assign({}, props, {
    strategy: strategy,
    schema: props.schema
  }));
};
export const SingleObjectDimensionEditor = {
  matchesEditorType: (report, schema) => {
    if (!isDimensionReportEditorSchema(schema)) {
      return false;
    }
    return strategy.isSupportedForReport(report);
  },
  EditorComponent: SingleObjectDimensionEditorComponent,
  category: ReportOptionsCategories.Group
};